const initialState = () => ({
  isGlobalDownloading: false,
});

const state = initialState();

export default state;
